import { render, staticRenderFns } from "./DetailPd02Page.vue?vue&type=template&id=100b6f65"
import script from "./DetailPd02Page.vue?vue&type=script&lang=js"
export * from "./DetailPd02Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports